export default __webpack_public_path__ + "e60c484d486316b2aaf819425d6911e1.png";